<template>
    <div class="div-msg">
        <el-tabs class="base-tabs" type="border-card">
            <el-tab-pane label="本机发送">
                <TableModelPlusEx :listArray="listArray_FS" :max-height="'150px'" ref="table_send"
                    :columns="columns_send" />
            </el-tab-pane>
            <el-tab-pane label="本机接收">
                <TableModelPlusEx :listArray="listArray_JS" :max-height="'150px'" ref="table_receive"
                    :columns="columns_receive" />
            </el-tab-pane>
            <el-tab-pane label="下属通信">
                <TableModelPlusEx :max-height="'150px'" ref="table_sub_com" :columns="columns_receive" />
            </el-tab-pane>
            <el-tab-pane label="实时位置">
                <TableModelPlusEx :listArray="listArray_WZ" :max-height="'150px'" ref="table_pos" :columns="columns_pos" />
            </el-tab-pane>
            <el-tab-pane label="围栏告警">
                <TableModelPlusEx :max-height="'150px'" ref="table_fence" :columns="columns_fence" />
            </el-tab-pane>
            <el-tab-pane label="维修任务">
                <TableModelPlusEx :max-height="'150px'" ref="table_m_task" :columns="columns_m_task" />
            </el-tab-pane>
            <el-tab-pane label="接收图片">
                <TableModelPlusEx :max-height="'150px'" ref="table_pic" :columns="columns_pic" />
            </el-tab-pane>
            <el-tab-pane label="接收语音">
                <TableModelPlusEx :max-height="'150px'" ref="table_voice" :columns="columns_voice" />
            </el-tab-pane>
        </el-tabs>
        <div class="signal-div">
            <div class="signal-label">信号强度</div>
            <div class="progress-div" v-for="(item, index) in percList">
                <el-progress :text-inside="true" :format="format" :key="index" :define-back-color="'#c3c3c3'"
                    :text-color="'#fff'" :percentage="item" :color="colors"></el-progress>
                <span class="span">{{ item }}</span>
            </div>

        </div>
    </div>
</template>
<script>
import util from "./util.js"
import { getLastMessage_FS, getLastMessage_JS, getLastLocation } from "@/api/communication/index.js"
import SpeechUti from "@/utils/SpeechUti"
import { getSurfaceHeight } from "@/utils/cesiumBD/analysis/utils/index"
import PopLayer from "@/utils/cesiumBD/animation/PopLayer"
import DeviceMsg from "../DeviceMsg/index.vue"
export default {
    data() {
        return {
            listArray_FS: [],
            listArray_JS: [],
            listArray_WZ: [],
            percList: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            colors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 30 },
                { color: '#5cb87a', percentage: 100 }
            ],
            path: WS_Server,
            socket: "",
            columns_send: [
                {
                    "label": "序号",
                    "type": "index",
                },

                {
                    "label": "时间",
                    "cusprop": "msgDateTime",
                    "component": "popContent"
                },
                {
                    "label": "接收方卡号",
                    "cusprop": "receiveBdNum",
                    "component": "popContent"
                },
                {
                    "label": "报文内容",
                    "cusprop": "msgContent",
                    "component": "popContent"
                },
            ],
            columns_receive: [
                {
                    "label": "序号",
                    "type": "index",
                },
                {
                    "label": "发送方卡号",
                    "cusprop": "sendBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "接收方卡号",
                    "cusprop": "receiveBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "时间",
                    "cusprop": "msgDateTime",
                    "component": "popContent"
                },
                {
                    "label": "报文内容",
                    "cusprop": "msgContent",
                    "component": "popContent"
                },
            ],
            columns_pos: [
                {
                    "label": "序号",
                    "type": "index",
                },
                {
                    "label": "发送方卡号",
                    "cusprop": "sendBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "接收方卡号",
                    // "cusprop": "receiveBdNum",
                    // "component": "popContent"
                    "cusprop": "receiveBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "时间",
                    "cusprop": "posDateTime",
                    "component": "popContent"
                },
                {
                    "label": "经度",
                    "cusprop": "lng",
                    "component": "popContent"
                },
                {
                    "label": "纬度",
                    "cusprop": "lat",
                    "component": "popContent"
                },
                {
                    "label": "高程",
                    "cusprop": "altitude",
                    "component": "popContent"
                },
                {
                    "label": "方向",
                    "cusprop": "course",
                    "component": "popContent"
                },
                {
                    "label": "速度",
                    "cusprop": "speed",
                    "component": "popContent"
                },
            ],
            columns_fence: [
                {
                    "label": "序号",
                    "type": "index",
                },
                {
                    "label": "卡号",
                    "cusprop": "cardNumber",
                    "component": "receiveCard"
                },
                {
                    "label": "报警内容",
                    "cusprop": "content",
                    "component": "popContent"
                },
                {
                    "label": "时间",
                    "cusprop": "createTime",
                    "component": "popContent"
                },
                {
                    "label": "经度",
                    "cusprop": "longitude",
                    "component": "popContent"
                },
                {
                    "label": "纬度",
                    "cusprop": "latitude",
                    "component": "popContent"
                }
            ],
            columns_m_task: [
                {
                    "label": "序号",
                    "type": "index",
                },
                {
                    "label": "发送方卡号",
                    "cusprop": "sendBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "内容",
                    "cusprop": "msgContent",
                    "component": "popContent"
                },
                {
                    "label": "时间",
                    "cusprop": "msgDateTime",
                    "component": "popContent"
                }
            ],
            columns_pic: [
                {
                    "label": "序号",
                    "type": "index",
                },
                {
                    "label": "发送方卡号",
                    "cusprop": "sendBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "内容",
                    "cusprop": [
                        {
                            "text": "点击查看图片",
                            "class": "edit",
                            "method": "openPic"
                        },
                    ],
                    "component": [
                        "comFun",
                    ]
                },
                {
                    "label": "时间",
                    "cusprop": "msgDateTime",
                    "component": "popContent"
                }
            ],
            columns_voice: [
                {
                    "label": "序号",
                    "type": "index",
                },
                {
                    "label": "发送方卡号",
                    "cusprop": "sendBdNum",
                    "component": "receiveCard"
                },
                {
                    "label": "内容",
                    "cusprop": [
                        {
                            "text": "点击查看语音",
                            "class": "edit",
                            "method": "openVoice"
                        },
                    ],
                    "component": [
                        "comFun",
                    ]
                },
                {
                    "label": "时间",
                    "cusprop": "msgDateTime",
                    "component": "popContent"
                }
            ]
        }
    },
    created() {
        this.speechUti = new SpeechUti();
        //this.speechUti.handleSpeak("收到北斗报文");
    },
    mounted() {

        this.getLastMessage_FS();
        this.getLastMessage_JS();
        this.getLastLocation();

        // 初始化
        this.init()

        //普通消息
        this.$bus.$on("sendMsg-MSG", (row) => {
            //this.$refs["table_send"] && this.$refs["table_send"].addFirst(row);
            var hex = util.utf8ToHex(JSON.stringify(row));
            this.send('$SUMSG,' + hex);
        });

        //发消息(通播)
        this.$bus.$on("sendMsg-CQ", (row) => {
            row.receiveCardNumber = row.broadcastNumber;
            //this.$refs["table_send"] && this.$refs["table_send"].addFirst(row);
            var hex = util.utf8ToHex(JSON.stringify(row));
            this.send('$SBMSG,' + hex);
        });

        //发消息(组播)
        this.$bus.$on("sendMsg-CM", (row) => {
            row.receiveCardNumber = row.receiveCardNumbers.join('、');
            //this.$refs["table_send"] && this.$refs["table_send"].addFirst(row);
            var hex = util.utf8ToHex(JSON.stringify(row));
            this.send('$SMMSG,' + hex);
        });

        //点名定位标识
        this.$bus.$on("sendMsg-POS", (row) => {
            //this.$refs["table_send"] && this.$refs["table_send"].addFirst(row);
            var hex = util.utf8ToHex(JSON.stringify(row));
            this.send('$SFPOS,' + hex);
        });
    },
    beforeDestroy() {
        this.$bus.$off("sendMsg-MSG");
        this.$bus.$off("sendMsg-CQ");
        this.$bus.$off("sendMsg-CM");
        this.$bus.$off("sendMsg-POS");
    },
    methods: {
        getLastMessage_FS() {
            getLastMessage_FS().then(res => {
                var result = res.result || result;
                this.listArray_FS = result;
            }).catch(e => {
                console.error(e);
            });
        },
        getLastMessage_JS() {
            getLastMessage_JS().then(res => {
                var result = res.result || result;
                // result.forEach(element => {
                //     element.sendBdNum = element.sendCardNumber;
                //     element.receiveBdNum = element.receiveCardNumber;
                //     element.msgDateTime = element.updateTime;
                //     element.msgContent = element.content;
                // });
                this.listArray_JS = result;
            }).catch(e => {
                console.error(e);
            });
        },
        getLastLocation() {
            getLastLocation().then(res => {
                var result = res.result || result;
                // result.forEach(element => {
                //     element.sendBdNum = element.sendCardNumber;
                //     element.receiveBdNum = element.receiveCardNumber;
                //     element.posDateTime = element.updateTime;
                //     element.msgContent = element.content;
                //     element.lng = element.longitude;
                //     element.lat = element.latitude;
                //     element.altitude = element.altitude;
                //     element.course = element.direction;
                // });
                this.listArray_WZ = result;
            }).catch(e => {
                console.error(e);
            });
        },
        format(percentage) {
            return "";
        },
        init: function () {
            if (typeof (WebSocket) === "undefined") {
                console.error("您的浏览器不支持socket")
            } else {
                // 实例化socket
                this.socket = new WebSocket(this.path)
                // 监听socket连接
                this.socket.onopen = this.open
                // 监听socket错误信息
                this.socket.onerror = this.error
                // 监听socket消息
                this.socket.onmessage = this.getMessage
                // 监听关闭
                this.socket.onclose = this.close
            }
        },
        open: function () {
            console.log("socket连接成功")
        },
        error: function () {
            console.log("连接错误")
        },
        updatePos(card) {
            var car_num = card.sendBdNum;
            if (car_num) {
                var entity = DBentityCollection.getById(car_num);
                var p = Cesium.Cartesian3.fromDegrees(card.lng, card.lat);
                if (!entity) {
                    getSurfaceHeight(viewer.scene, p, {
                        has3dtiles: false,
                        asyn: true,
                        calback: (heightTerrain, carto) => {
                            var heightPos = Cesium.Cartesian3.fromDegrees(card.lng, card.lat, heightTerrain);
                            entity = this.createBillboardEntity(heightPos, car_num);
                            DBentityCollection.add(entity);
                            var pop = new PopLayer({
                                entity: entity,
                                dialog: this.$dialog,
                                componet: DeviceMsg,
                                subData: car_num,
                                title: "设备信息"
                            });

                            entity.show = false;
                            // viewer.flyTo(entity, {
                            //     duration: 3,
                            //     offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 1500),//（heading,pich,range）
                            // });
                        }
                    })


                    return;

                }

                getSurfaceHeight(viewer.scene, p, {
                    has3dtiles: false,
                    asyn: true,
                    calback: (heightTerrain, carto) => {
                        var heightPos = Cesium.Cartesian3.fromDegrees(card.lng, card.lat, heightTerrain);
                        entity.position.setValue(heightPos);
                        // if (entity.show) {
                        //     viewer.flyTo(entity, {
                        //         duration: 3,
                        //         offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 1500),//（heading,pich,range）
                        //     });
                        // }
                    }
                })
            }

        },
        //图标
        createBillboardEntity(center, id) {
            const entity = new Cesium.Entity({
                id: id,
                position: center,
                billboard: {
                    image: "data/img/marker/mark2.png",
                    scale: 1.0,
                    horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    heightReference: Cesium.HeightReference.NONE,
                },
            });
            return entity;
        },
        getMessage: function (res) {
            var data = res.data;
            if (data) {
                let type = data.split(",")[0];
                let msg = util.hexToUtf8(data.split(",")[1]);
                console.log(type);
                console.log(JSON.parse(msg));
                //发送消息
                if (type == "$RSMSG") {
                    this.$refs["table_send"] && this.$refs["table_send"].addFirst(JSON.parse(msg));
                }
                //接收消息
                if (type == "$RMSG") {
                    //语音播放
                    this.speechUti.handleSpeak("收到北斗报文");
                    this.$refs["table_receive"] && this.$refs["table_receive"].addFirst(JSON.parse(msg));
                    //communicateType    1 下属
                    //table_sub_com
                    if (JSON.parse(msg).communicateType == 1) {
                        this.$refs["table_sub_com"] && this.$refs["table_sub_com"].addFirst(JSON.parse(msg));
                    }
                }
                //实时位置:TODO
                if (type == "$RPOS") {
                    this.$refs["table_pos"] && this.$refs["table_pos"].addFirst(JSON.parse(msg));
                    this.updatePos(JSON.parse(msg));
                }
                //卫星信号
                if (type == "$RBSI") {
                    var data = JSON.parse(msg);
                    var beamSignals = data.beamSignals || Array(10).fill(0);
                    this.percList = beamSignals;
                }
                //接收告警信息
                //{"carNumber":"1859807","cardNumber":1859807,"content":"禁出报警","createTime":"2023-04-11 15:33:49","latitude":32.45780555555556,"longitude":119.88416666666667,"state":1,"type":2,"updateTime":"2023-04-11 15:33:49"}
                if (type == "$RALARM") {
                    this.$refs["table_fence"] && this.$refs["table_fence"].addFirst(JSON.parse(msg));
                }

                //维修任务
                //{"communicateType":0,"communicateTypeStr":"本机通信","contentType":0,"id":0,"msgContent":"维修结果:NUM-00004,052C,ПА 模块,ТХ1-В-1-01模块,表页显示器","msgDateTime":"2023-04-18 15:22:50","msgType":0,"receiveBdNum":0,"sendBdNum":1859807}
                if (type == "$RMSGWX") {
                    this.$refs["table_m_task"] && this.$refs["table_m_task"].addFirst(JSON.parse(msg));
                }

                //接收图片
                if (type == "$RMSGPIC") {
                    this.$refs["table_pic"] && this.$refs["table_pic"].addFirst(JSON.parse(msg));
                }
                //接收语音
                if (type == "$RMSGWAV") {
                    this.$refs["table_voice"] && this.$refs["table_voice"].addFirst(JSON.parse(msg));
                }
            }
        },
        send: function (data) {
            this.socket.send(data)
        },
        close: function () {
            console.log("socket已经关闭")
        }
    },
    destroyed() {
        // 销毁监听
        this.socket.close();
        this.socket = null;

    }
}
</script>
<style lang="scss">
.div-msg {
    .el-tabs--border-card>.el-tabs__content {
        padding: 15px;
        height: 150px;
    }

    .signal-div {
        position: fixed;
        bottom: 340px;
        right: 30px;
        pointer-events: none;
        width: 90px;

        .progress-div {
            display: flex;
            flex-direction: row;
            align-items: center;

            .el-progress {
                width: 90%;
            }

            .span {
                width: 10%;
                color: #fff;
                font-size: 12px;
                margin-left: 6px;
            }
        }

        .signal-label {
            position: absolute;
            color: #c3c3c3;
            font-size: 12px;
            left: 0;
            top: -20px;
            width: 100%;
            text-align: center;
        }
    }
}
</style>